// =============================================================================
// newRequestSwitch.ts — the "can DFV Services start a new request?" switch
// =============================================================================
// An admin switch (Manage → System Setup → Config) that turns the "+ New Request"
// button off, e.g. when intake is closed. Stored in portal_config.
//
// SCOPE (John, 6 Aug 2026): NEW requests only. Existing DRAFTS can still be
// finished and submitted, so nobody is stranded part-way through work they've
// already started. Editing and viewing are unaffected.
//
// PRESENTATION (John's call): the button is simply HIDDEN — no explanatory panel.
// Someone who lands on /requests/new directly (a bookmark, or the page left open
// when the switch was thrown) is sent back to their request list rather than shown
// a broken or empty screen.
//
// ⚠️ FAIL-OPEN. A missing key, a failed read, or a corrupt value must resolve to
// ENABLED. Intake accidentally staying open is a nuisance; intake silently closing
// because a config read failed would look like the portal is broken and would stop
// DFV Services getting help to children.
// =============================================================================

export const NEW_REQUESTS_KEY = "new_requests_enabled";

// Only an explicit false (or the string "false", as a JSON round-trip can yield)
// turns it off. Anything else — null, undefined, junk — means enabled.
export function normalizeNewRequestsEnabled(value: unknown): boolean {
  if (value === false || value === "false") return false;
  if (value && typeof value === "object") {
    const enabled = (value as { enabled?: unknown }).enabled;
    return !(enabled === false || enabled === "false");
  }
  return true;
}
